export default "__VITE_PUBLIC_ASSET__53ad863b__"